var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('small',{staticClass:"form-text text-muted",domProps:{"textContent":_vm._s(_vm.description)}})}
var staticRenderFns = []

export { render, staticRenderFns }